import React, { useEffect, useRef, useState } from 'react';
import { Book, Rendition } from 'epubjs';

const EPUBViewer = ({ file }) => {
  const viewerRef = useRef(null);
  const bookRef = useRef(null);
  const renditionRef = useRef(null);
  const [atStart, setAtStart] = useState(true);
  const [atEnd, setAtEnd] = useState(false);

  useEffect(() => {
    if (viewerRef.current) {
      bookRef.current = new Book(file);
      renditionRef.current = new Rendition(bookRef.current, {
        width: '100%',
        height: '100%',
        spread: 'none'
      });

      renditionRef.current.attachTo(viewerRef.current);

      // Add location changed handler
      renditionRef.current.on('locationChanged', (location) => {
        setAtStart(location?.start === 0);
        setAtEnd(location?.end === location?.total - 1);
      });

      bookRef.current.ready.then(() => {
        renditionRef.current.display();
      });
    }

    return () => {
      if (renditionRef.current) {
        renditionRef.current.destroy();
      }
      if (bookRef.current) {
        bookRef.current.destroy();
      }
    };
  }, [file]);

  const handlePrev = () => {
    if (renditionRef.current) {
      renditionRef.current.prev();
    }
  };

  const handleNext = () => {
    if (renditionRef.current) {
      renditionRef.current.next();
    }
  };

  return (
    <div className="h-full w-full flex flex-col">
      <div 
        ref={viewerRef} 
        className="flex-1 overflow-auto bg-white"
      />
      
      {/* Navigation Controls */}
      <div className="border-t border-zinc-200 bg-zinc-50 p-2 flex justify-center space-x-4">
        <button
          onClick={handlePrev}
          disabled={atStart}
          className={`px-4 py-2 rounded-lg ${
            atStart 
              ? 'bg-zinc-200 text-zinc-400 cursor-not-allowed' 
              : 'bg-zinc-800 text-white hover:bg-zinc-700'
          }`}
        >
          Previous
        </button>
        <button
          onClick={handleNext}
          disabled={atEnd}
          className={`px-4 py-2 rounded-lg ${
            atEnd 
              ? 'bg-zinc-200 text-zinc-400 cursor-not-allowed' 
              : 'bg-zinc-800 text-white hover:bg-zinc-700'
          }`}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default EPUBViewer;